module.exports = __webpack_public_path__ + "img/loading_small_white.55b5ff0d.webp";